// extracted by mini-css-extract-plugin
export default {"TabContents":"TabContents_TabContents__JF5aZ","mobile":"TabContents_mobile__LKyRX"};